import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../utils/Seo';
import { db } from '../firebase';
import {
  collection,
  getDocs,
  query,
  orderBy,
  getDoc,
  doc,
  onSnapshot
} from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';
import ChapterContent from './ChapterContent';

export default function ChapterList() {
  const totalChapters = 2;
  const { currentUser } = useAuth();
  const [chapters, setChapters] = useState([]);
  const [unlocked, setUnlocked] = useState([]);
  const [UNLOCK_ALL, setUNLOCK_ALL] = useState(false); // Now state

  /// TESTING: Set to true to unlock all chapters
  //const UNLOCK_ALL = true; // <-- set to true for testing

  useEffect(() => {
    // Fetch "visibility" from "siteManagement/characters"
    const fetchVisibility = async () => {
      try {
        const docRef = doc(db, 'siteManagement', 'chapters');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUNLOCK_ALL(!!docSnap.data().visible);
        } else {
          console.log('No such document for site management!');
        }
      } catch (error) {
        console.error('Error fetching visibility:', error);
      }
    };
    fetchVisibility();
  }, []);

  // Unlock logic
  const isUnlocked = (chapterId) => {
    if (UNLOCK_ALL) return true;
    return unlocked.includes(chapterId);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const chaptersQuery = query(
          collection(db, 'chapters'),
          orderBy('order')
        );
        const chaptersSnapshot = await getDocs(chaptersQuery);
        const chaptersData = chaptersSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        if (currentUser?.uid) {
          const unlocksDoc = await getDoc(doc(db, 'userUnlocks', currentUser.uid));
          setUnlocked(unlocksDoc.exists()
            ? unlocksDoc.data().unlockedChapters || []
            : []);
            // Log the list of unlocked chapters to the console
        console.log('Unlocked Chapters:', unlocksDoc);
        }

        setChapters(chaptersData);
      } catch (error) {
        console.error('Error loading chapters:', error);
      }
    };

    const unsubscribe = onSnapshot(collection(db, 'chapters'), fetchData);
    fetchData();
    return () => unsubscribe();
  }, [currentUser?.uid]);

  return (
    <div className="container mt-5">
      <Seo
        title="Capítulos de Noche de Muertos"
        description="Explora los capítulos de la aventura de Valentina en el Día de Muertos."
        />
      <div className="row">
        <div className="col-md-8">
          <h2 className='h2-bg'>Esta es la historia de una Noche de Muertos...</h2>
          <p className='section_intro'>
            Esta aventura también es digital. Puedes leer el libro físico y desbloquear contenido especial al escanear los códigos QR al final de cada capítulo. ¡Regresa con frecuencia! Nunca sabes qué sorpresas podrías encontrar.
          </p>
        </div>
      </div>
      
      <div className="row">
        <div key="free-chapter" className="mb-4 col-md-6 hover-effect">
          <Link to="/salida-a-tzintzuntzan" className="text-decoration-none text-reset">
            <div className="chapter-card rounded shadow bg-light" style={{ backgroundImage: `url(https://diadelavida.com/images/numbers/1.png)` }}>
              <h3><span>1</span> Salida a Tzintzuntzan</h3>
              <div>
                <p>Valentina sale juntos a sus papás a visitar a su familia y celebrar la tradicional Noche de Muertos, sin saber la aventura que tiene por delante.</p>
              </div>
            </div>
          </Link>
        </div>
        {chapters.map((chapter) => {
          const chapterUnlocked = isUnlocked(chapter.id);

          if (chapter.hidden) return null;
          return (
            <div key={chapter.id} className="mb-4 col-md-6 hover-effect">
              {chapterUnlocked ? (
                <Link
                  to={chapter.requiredUrl}
                  className="text-decoration-none text-reset"
                >
                  <ChapterContent
                    chapter={chapter}
                    isUnlocked={chapterUnlocked}
                  />
                </Link>
              ) : (
                <div className="text-decoration-none text-reset locked-container">
                  <ChapterContent
                    chapter={chapter}
                    isUnlocked={chapterUnlocked}
                  />
                </div>
              )}
            </div>
          );
        })}

        {unlocked.length === totalChapters && chapters.length > 0 && (
          <div key="free-chapter" className="mb-4 col-md-12 hover-effect">
            <Link to="/7pX9qR2tK5wY8vZ3sN6cB4mH1dL" className="text-decoration-none text-reset">
              <div className="chapter-card special rounded shadow bg-light">
                <h3>Capítulo Especial</h3>
                <div>
                  <p>Ahora que terminaste el libro...</p>
                </div>
              </div>
            </Link>
          </div>
        )}

      </div>
    </div>
  );
}